import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { useLocation } from "react-router-dom";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";

import { ALL_CONTENT_INFOS, DELETE_CONTENT_INFO } from "../queries/GraphQLQueries";
import CustomAlert from "./CustomAlert";
import { useDialogNavigation } from "../hooks/useDialogNavigation";

export default function DeleteContentDialogBox() {
    const handleCancel = useDialogNavigation();
    const { state } = useLocation();
    const { contentId, contentName } = state || {};

    const [alertMessage, setAlertMessage] = useState(null);
    const [deleteContentMutation] = useMutation(DELETE_CONTENT_INFO, {
        refetchQueries: [
            { query: ALL_CONTENT_INFOS }, 'GetContentInfos'
        ]
    });

    const handleCloseCustomAlert = () => {
        setAlertMessage(null);
    };

    function handleDelete() {
        setAlertMessage({ children: 'Deleting content {contentName}...', severity: 'success' });
        deleteContentMutation({
            variables: {
                id: contentId
            }
        }).then(() => {
            handleCancel();
            setAlertMessage({ children: 'Content {contentName} deleted.', severity: 'success' });
        }).catch((e) => {
            setAlertMessage({ children: e?.message, severity: 'error' });
        });
    }

    return <>
        <Dialog open={true} onClose={handleCancel} aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description" disableRestoreFocus>

            <DialogTitle id="confirmation-dialog-title">Delete Confirmation</DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    Are you sure you want to delete "<b>{contentName}</b>"? <br></br>
                    This will not remove the content from any existing plans or bookings.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="primary" variant="contained">
                    Cancel
                </Button>
                <Button onClick={handleDelete} color="primary" variant="contained">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
        <CustomAlert alertMessage={alertMessage} handleCloseCustomAlert={handleCloseCustomAlert} />
    </>;
}